import { Button } from '@mui/material'
import MuiAppBar from '@mui/material/AppBar'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { styled } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import LanguagePicker from './LanguagePicker'
import ThemeModePicker from './ThemeModePicker'

const StyledAppBar = styled(MuiAppBar)(({ theme }) => ({
  displayPrint: 'none',
  '& .MuiButton-root': {
    color: 'inherit',
  },
  '& .MuiIconButton-root': {
    color: 'inherit',
  },
  '& .MuiInputBase-root': {
    color: 'inherit',
  },
  '& .MuiInputBase-input': {
    color: 'inherit',
  },
  '& .MuiSelect-icon': {
    color: 'inherit',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.white,
  },
  '& .MuiSelect-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.white,
  },
}))

const NavigationHeader = () => {
  const { t } = useTranslation()
  return (
    <StyledAppBar position="static" color="secondary">
      <Toolbar>
        <Button href="/" sx={{ flexShrink: 0, mr: 2 }}>
          <img src="/images/iFinance-white.svg" alt="Iceberg Finance" style={{ width: '110px', height: '40px' }} />
        </Button>
        <span style={{ flexGrow: 0.9 }}>&nbsp;</span>
        <List>
          <ListItem disablePadding sx={{ display: 'flex', flexDirection: 'row' }}>
            <ListItemButton component={Link} to="/Homepage">
              <ListItemText primary={t('menus.home')} />
            </ListItemButton>

            <ListItemButton component={Link} to="/import">
              <ListItemText primary={t('menus.import')} />
            </ListItemButton>

            <ListItemButton component={Link} to="/people">
              <ListItemText primary={t('menus.people')} />
            </ListItemButton>

            <ListItemButton component={Link} to="/exceptions">
              <ListItemText primary={t('menus.approvedRemoteExceptions')} />
            </ListItemButton>

            <ListItemButton component={Link} to="/leadtime">
              <ListItemText primary={t('menus.leadTime')} />
            </ListItemButton>

            <ListItemButton component={Link} to="/dvi">
              <ListItemText primary={t('menus.dvi')} />
            </ListItemButton>

            <ListItemButton component={Link} to="/techdebt">
              <ListItemText primary={t('menus.techDebt')} />
            </ListItemButton>
          </ListItem>
        </List>
        <LanguagePicker />
        <ThemeModePicker />
      </Toolbar>
    </StyledAppBar>
  )
}

export default NavigationHeader
